module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0045.jpg?v=9edf380d";